export default {
  UPLOAD_IMAGE_START: "UPLOAD_IMAGE_START",
  UPLOAD_IMAGE_SUCCESS: "UPLOAD_IMAGE_SUCCESS",
  UPLOAD_IMAGE_ERROR: "UPLOAD_IMAGE_ERROR",
};
